import { IResCrearPonderacion, IResValidarNotas } from 'src/app/interfaces/ponderaciones';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { ICalificacion, IExamen, IRegistroCalificacion } from './../../../interfaces/ponderaciones';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-config-registro-calif',
  templateUrl: './config-registro-calif.component.html',
  styleUrls: ['./config-registro-calif.component.scss']
})
export class ConfigRegistroCalifComponent {
  calificacionesParciales: Array<ICalificacion> = []
  calificacionesExamenes: Array<IExamen> = []
  registroCalificaciones: Array<IRegistroCalificacion> = []
  activarExamenExtraordinario: boolean = false

  ponderacionId: number = 0;
  minParciales: number = 1
  maxParciales: number = 20
  cantidadCajasParciales: number = 0

  minExamenes: number = 0
  maxExamenes: number = 2
  cantidadCajasExamenes: number = 0

  textoError: string = ''
  registros: any = null

  datosConfiguracion: any = {};
  configuraciones: any = {};

  infoModalTitulo: string = ''
  infoModalTexto: string = ''

  deshabilitarCrear: boolean = false

  esVerDetalle: boolean = false
  configuracionFiltros: any = {};
  alertaExitosa: string = ''

  isLoading: boolean = true

  ngOnInit() {
    this.getConfiguracionRegistroCalificacion()
  }

  constructor(
    private _ponderaciones: PonderacionesService,
    private router: Router
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( !routerData ) {
      this.router.navigate(['/portal-calificacion'])
    }

    if (routerData?.ponderacionEditada) {
      this.alertaExitosa = "La configuración del registro se ha guardado exitosamente.";
      setTimeout(() => {
        this.alertaExitosa = "";
      }, 15000);
    }
    if (routerData?.configuracion != null) {
      this.configuraciones = routerData.configuracion;
    }
    if (routerData?.filtros) {
      this.configuracionFiltros = routerData.filtros;
    }
  }
  volverAPortal(): void {
    this.router.navigate(['/portal-calificacion'], {
      state: {
        data: {
          filtros: this.configuracionFiltros,
          configuracion: this.configuraciones
        }
      }
    })
  }

  fnCaseCalificacionesParciales(): void {
    let minimoParciales = this.registros.cantidadMinimaNotas
    if (this.cantidadCajasParciales >= this.maxParciales) {
      this.cantidadCajasParciales = this.maxParciales
    }
    if (this.cantidadCajasParciales <= minimoParciales) {
      this.cantidadCajasParciales = minimoParciales
    }
    let tmpCalifParciales = []
    let cantidadExistente = this.cantidadCajasParciales > this.calificacionesParciales.length ? this.calificacionesParciales.length : this.cantidadCajasParciales
    for (let index = 0; index < cantidadExistente; index++) {
      tmpCalifParciales.push({ porcentaje: this.calificacionesParciales[index].porcentaje, glosa: this.calificacionesParciales[index].glosa })
    }
    for (let index = cantidadExistente; index < this.cantidadCajasParciales; index++) {
      if (this.registros.promedioNotas.length > index) {
        tmpCalifParciales.push({ porcentaje: this.registros.promedioNotas[index].porcentaje, glosa: this.registros.promedioNotas[index].glosa })
      } else {
        tmpCalifParciales.push({ porcentaje: 0, glosa: '' })
      }
    }
    this.calificacionesParciales = tmpCalifParciales
  }

  fnCaseCalificacionesExamenes(): void {
    let minimoExamenes = this.registros.cantidadMinimaExamenes
    if (this.cantidadCajasExamenes >= this.maxExamenes) {
      this.cantidadCajasExamenes = this.maxExamenes
    }
    if (this.cantidadCajasExamenes <= minimoExamenes) {
      this.cantidadCajasExamenes = minimoExamenes
    }

    let tmpCalifExam = []
    let cantidadExistenteEx = this.cantidadCajasExamenes > this.calificacionesExamenes.length ? this.calificacionesExamenes.length : this.cantidadCajasExamenes

    for (let index = 0; index < cantidadExistenteEx; index++) {
      tmpCalifExam.push({ porcentajeE: this.calificacionesExamenes[index].porcentajeE, glosa: this.calificacionesExamenes[index].glosa })
    }

    for (let index = cantidadExistenteEx; index < this.cantidadCajasExamenes; index++) {
      if (this.registros.promedioExamenes.length > index) {
        tmpCalifExam.push({ porcentajeE: this.registros.promedioExamenes[index].porcentaje, glosa: this.registros.promedioExamenes[index].glosa })
      } else {
        tmpCalifExam.push({ porcentajeE: 0, glosa: '' })
      }
    }
    this.calificacionesExamenes = tmpCalifExam
  }

  ingresoCajasPonderaciones(tipo: string) {
    let timeout = "";
    clearTimeout(timeout);
    setTimeout(() => {
      switch (tipo) {
        case 'calificacionesParciales':
          this.fnCaseCalificacionesParciales()
          break;
        case 'calificacionesExamenes':
          this.fnCaseCalificacionesExamenes()
          break;
        default:
          break;
      }
    }, 1000);
  }

  quitarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParciales.pop()
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenes.pop()
        break;
      default:
        break;
    }
  }

  agregarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParciales = [...this.calificacionesParciales, { porcentaje: 0, glosa: '' }]
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenes = [...this.calificacionesExamenes, { porcentajeE: 100 }]
        break;
      default:
        break;
    }
  }

  totalParciales() {
    let porcentaje: number = 0
    this.calificacionesParciales.forEach((calificacion: ICalificacion) => {
      porcentaje += calificacion.porcentaje
    })
    return porcentaje
  }

  totalExamenes() {
    let porcentajeEx: number = 0
    this.calificacionesExamenes.forEach((calificacion: IExamen) => {
      porcentajeEx += calificacion.porcentajeE
    })
    return porcentajeEx
  }

  getConfiguracionRegistroCalificacion() {
    let body = {
      anyo: this.configuraciones.anyo,
      periodoId: this.configuraciones.periodoId,
      sedeId: this.configuraciones.sedeId,
      idSeccion: this.configuraciones.idSeccion,
      idAsignatura: this.configuraciones.idAsignatura,
      ponderacionBaseId: this.configuraciones.ponderacionBaseId
    }

    this._ponderaciones.obtenerRegistroCalificaciones(body).subscribe(
      (res: IRegistroCalificacion) => {
        this.isLoading = false
        this.registros = res
        this.minParciales = res.cantidadMinimaNotas

        for (let index = 0; index < res.cantidadNotas; index++) {
          let porcentaje = { porcentaje: res.promedioNotas[index].porcentaje }
          this.calificacionesParciales[res.promedioNotas[index].numeroNota - 1] = porcentaje
          this.cantidadCajasParciales = this.calificacionesParciales.length

          this.calificacionesParciales[index].glosa = res.promedioNotas[index].glosa
        }
        this.minExamenes = res.cantidadMinimaExamenes

        for (let index = 0; index < res.cantidadExamenes; index++) {
          const porcentaje = { porcentajeE: res.promedioExamenes[index].porcentaje }
          this.calificacionesExamenes[res.promedioExamenes[index].numeroNota - 1] = porcentaje;
          this.cantidadCajasExamenes = this.calificacionesExamenes.length
          this.calificacionesExamenes[index].glosa = res.promedioExamenes[index].glosa
        }
        this.activarExamenExtraordinario = res.examenExtraordinario;


        if (this.configuraciones.esEditable === false) {
          this.esVerDetalle = true

        }
      }, err => {
      }
    )
  }

  switchExamenExtraordinario() {
    this.activarExamenExtraordinario = !this.activarExamenExtraordinario;
  }

  limpiarTextoError() {
    document.getElementById('idBreadcrumb')?.scrollIntoView()
    setTimeout(() => {
      this.textoError = ''
    }, 15000)
  }
  modalAvisoDebeSer100(texto: string = 'El total de las ponderaciones de las calificaciones parciales debe ser 100%') {
    this.textoError = texto
    this.limpiarTextoError()
  }

  validarPonderaciones() {
    const settingParcialEnCero = this.calificacionesParciales.filter((parcial: any) => parcial.porcentaje === 0)
    const examenesEnCero = this.calificacionesExamenes.filter((examen: any) => examen.porcentajeE === 0)
    let promedioCalificacionesParciales: number = 0
    let promedioCalificacionesExamenes: number = 0
    this.calificacionesParciales.forEach((parcial: any) => {
      promedioCalificacionesParciales += parcial.porcentaje
    })
    this.calificacionesExamenes.forEach((examen: any) => {
      promedioCalificacionesExamenes += examen.porcentajeE
    })
    if (settingParcialEnCero.length > 0 || examenesEnCero.length > 0) {
      this.modalFaltaPonderacion()
      return false
    }
    if (promedioCalificacionesParciales !== 100) {
      this.modalAvisoDebeSer100('El total de las ponderaciones de las calificaciones parciales debe ser 100%')
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false
    }
    if (this.calificacionesExamenes.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoDebeSer100('El total de las ponderaciones del examen debe ser 100%')
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false
    }
    if (this.calificacionesExamenes.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoDebeSer100('El total de las ponderaciones del examen debe ser 100%')
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false
    }
    return true
  }

  modalFaltaPonderacion() {
    this.infoModalTitulo = 'Aviso'
    this.infoModalTexto = 'Debes completar todas las ponderaciones de las calificaciones agregadas <br> <span>Las ponderaciones no deben ser 0</span>'
    document.getElementById('btn-modal-info')?.click()
  }

  validarNotas(): void {
    this._ponderaciones.validarNotas(
      this.configuraciones.anyo, 
      this.configuraciones.periodoId, 
      this.configuraciones.sedeId, 
      this.configuraciones.idSeccion
    ).subscribe(
      (res: IResValidarNotas) => {
        if ( res.error === null ) {
          if ( !res.valor ) {
            document.getElementById('modal-confirmar')?.click()
          } else {
            document.getElementById('modal-notas-ingresadas-btn')?.click()
          }
        } else {
          this.infoModalTitulo = 'Aviso'
          this.infoModalTexto = res?.error?.mensaje ?? 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }
    )
  }

  fnNotasParciales(): Array<any> {
    let notasParciales: Array<any> = []
    this.calificacionesParciales.forEach((element, index) => {
      let notaTmp: any

      if (index < this.registros.promedioNotas.length) {
        notaTmp = this.registros.promedioNotas[index]
        notaTmp.porcentaje = element.porcentaje;

      } else {
        notaTmp = Object.assign({}, this.registros.promedioNotas[0])
        notaTmp.porcentaje = element.porcentaje;
        notaTmp.numeroNota = index + 1;
      }
      notaTmp.glosa = element.glosa
      notasParciales.push(notaTmp)
    });
    return notasParciales
  }

  fnNotasExamenes(options = {examenExtraordinario: false}): Array<any> {
    let notasExamenes: Array<any> = []
    let notasExamenesExtraordinario: Array<any> = []
    this.calificacionesExamenes.forEach((element, index) => {
      let notaTmp: any;
      let notaTmpEx: any
      if (index < this.registros.promedioExamenes.length) {
        notaTmp = this.registros.promedioExamenes[index]
        notaTmp.porcentaje = element.porcentajeE;
      } else {
        notaTmp = Object.assign({}, this.registros.promedioExamenes[0])
        notaTmp.porcentaje = element.porcentajeE;
        notaTmp.numeroNota = index + 1;
        notaTmp.detallePonderacionId = null;
      }
      if (index < this.registros.promedioExamenesExtraordinario.length) {
        notaTmpEx = this.registros.promedioExamenesExtraordinario[index]
        notaTmpEx.porcentaje = element.porcentajeE;
        notaTmpEx = Object.assign({}, this.registros.promedioExamenesExtraordinario[index])
        notaTmpEx.numeroNota = index + 1;
      } else {
        notaTmpEx = Object.assign({}, this.registros.promedioExamenesExtraordinario[0])
        notaTmpEx.porcentaje = element.porcentajeE;
        notaTmpEx.numeroNota = index + 1;
        notaTmpEx.detallePonderacionId = null;
      }
      notaTmp.tipoNota = "CE";
      notaTmp.ponderacionBaseId = this.configuraciones.ponderacionBaseId;
      notaTmp.glosa = element.glosa

      notasExamenes.push(notaTmp)
      if (this.activarExamenExtraordinario) {
        notaTmpEx.tipoNota = "EX";
        notaTmpEx.ponderacionBaseId = this.configuraciones.ponderacionBaseId;
        notasExamenesExtraordinario.push(notaTmpEx);
      }
    });
    return options.examenExtraordinario ? notasExamenesExtraordinario : notasExamenes
  }

  guardar() {
    if (!this.validarPonderaciones()) {
      return
    }
    const notasParciales = this.fnNotasParciales()
    let notasExamenes = this.fnNotasExamenes()
    let notasExamenesExtraordinario = this.fnNotasExamenes({examenExtraordinario: true})
    
    const body: any = {
      configuracion: {
        anyo: this.configuraciones.anyo,
        periodoId: this.configuraciones.periodoId,
        sedeId: this.configuraciones.sedeId,
        seccionId: this.configuraciones.idSeccion,
        asignaturaId: this.configuraciones.idAsignatura,
        ponderacionBaseId: this.configuraciones.ponderacionBaseId
      },
      cantidadNotas: this.calificacionesParciales.length,
      promedioNotas: notasParciales,
      cantidadExamenes: this.calificacionesExamenes.length,
      promedioExamenes: notasExamenes,
      examenExtraordinario: this.activarExamenExtraordinario,
      promedioExamenesExtraordinario: this.activarExamenExtraordinario ? notasExamenesExtraordinario : []
    }

    this._ponderaciones.modificarRegistroCalificaciones(body).subscribe(
      (res: IResCrearPonderacion) => {
        if (res.error === null) {
          this.alertaExitosa = "La configuración del registro se ha guardado exitosamente."
          this.getConfiguracionRegistroCalificacion()
          $('html, body').animate({
            scrollTop: 0
          }, 500);
          setTimeout(() => {
            this.alertaExitosa = "";
          }, 15000);

        } else {
          this.infoModalTitulo = 'Aviso'
          this.infoModalTexto = 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }, (err: any) => {
      }
    )
  }

}
